import { render, staticRenderFns } from "./the-add-recharge-package.vue?vue&type=template&id=3f38c9ba&scoped=true&"
import script from "./the-add-recharge-package.vue?vue&type=script&lang=js&"
export * from "./the-add-recharge-package.vue?vue&type=script&lang=js&"
import style0 from "./the-add-recharge-package.vue?vue&type=style&index=0&id=3f38c9ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f38c9ba",
  null
  
)

export default component.exports